import { useEffect, useRef } from 'react';
import api from '../../authentication/axiosInstance';

// Detail GETs and inbox polling never record reads. Report a loaded detail only
// while its tab is visible, retrying failed reports on resume or data refresh.
export default function useMessageRead(message) {
  const recorded = useRef(null);
  const kind = message?.kind;
  const id = message?.id;
  useEffect(() => {
    if (!kind || !id) return undefined;
    const key = `${kind}:${id}`;
    let pending = false;
    let cancelled = false;
    const report = () => {
      if (pending || recorded.current === key || document.visibilityState === 'hidden' || navigator.onLine === false) return;
      pending = true;
      Promise.resolve().then(() => api.post('/mobile/read/', { kind, id: Number(id) }))
        .then(() => { if (!cancelled) recorded.current = key; })
        .catch(() => {}) // Retry on the next refresh/resume; never interrupt an answer.
        .finally(() => { pending = false; });
    };
    report();
    document.addEventListener('visibilitychange', report);
    window.addEventListener('focus', report);
    window.addEventListener('pageshow', report);
    window.addEventListener('online', report);
    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', report);
      window.removeEventListener('focus', report);
      window.removeEventListener('pageshow', report);
      window.removeEventListener('online', report);
    };
  }, [message, kind, id]);
}
